<div class="student-info-panel-row">
  <div class="student-attributes">
    <div *ngIf="imageBlobUrl">
      <!-- student has photo -->
      <img [src]="imageBlobUrl" alt="Student photo" class="student-photo" />
    </div>
    <div *ngIf="!imageBlobUrl && isDemoSite()">
      <!-- demo site -->
      <img
        src="../../assets/images/ZillaMonster_thumbnail.svg"
        alt="Student photo"
        class="student-photo"
      />
    </div>
    <div class="student-data-div">
      <div *ngIf="studentData && studentData.studentKEY">
        <h2 class="student-data">
          <span *ngIf="studentData.firstName !== '-----'"
            >{{ studentData.firstName }}
          </span>
          <span *ngIf="studentData.lastName !== '-----'">{{
            studentData.lastName
          }}</span>
          <span
            *ngIf="
              studentData.firstName === '-----' &&
              studentData.lastName === '-----'
            "
          >
            (name not provided)
          </span>
        </h2>
        <h3 class="student-subdata first-student-subdata">
          <a
            [routerLink]="'/profile/school/' + studentData['systemSchoolId']"
            (click)="setTitle('School Profile')"
            >{{ studentData.SchoolName_Official }}</a
          >
        </h3>
        <h3 class="student-subdata">
          <span class="student-subdata-label">Current Grade Level:</span>
          {{ studentData.demographics["Current Grade Level"] }}
        </h3>
        <h3 class="student-subdata" *ngIf="studentData.demographics['Gender']">
          <span class="student-subdata-label">Gender:</span>
          {{ studentData.demographics.Gender }}
        </h3>
        <h3 class="student-subdata" *ngIf="studentData.systemStudentID">
          <span class="student-subdata-label">System Student ID:</span>
          {{ studentData.systemStudentID }}
        </h3>
      </div>
      <div *ngIf="studentData && expandedView">
        <span *ngFor="let demographic of getDemographicKeys()">
          <h3 class="student-subdata" *ngIf="demographicToShow(demographic)">
            <span class="student-subdata-label">{{ demographic }}:</span>
            {{ studentData.demographics[demographic] }}
          </h3>
        </span>
      </div>
      <div
        *ngIf="studentData && studentData.studentKEY"
        class="show-hide-expanded-btns"
      >
        <button
          class="btn btn-link"
          *ngIf="!expandedView"
          (click)="toggleExpandedView(true)"
        >
          Show more
          <img
            [src]="'../../assets/images/show_more_gray600.png'"
            class="toggleShowImg"
          />
        </button>
        <button
          class="btn btn-link"
          *ngIf="expandedView"
          (click)="toggleExpandedView(false)"
        >
          Show less
          <img
            [src]="'../../assets/images/show_less_gray600.png'"
            class="toggleShowImg"
          />
        </button>
      </div>
      <div
        *ngIf="!studentData || !studentData.studentKEY"
        class="student-data-container"
      >
        No student metadata available!
      </div>
    </div>
  </div>
  <div class="student-info-dropdowns">
    <div
      class="schools-dropdown"
      *ngIf="schoolsDropdown && initialSchool && schoolsDropdown.length > 1"
    >
      <ng-select
        [items]="schoolsDropdown"
        bindLabel="text"
        (change)="changeSchool($event)"
        [(ngModel)]="initialSchool"
        [clearable]="false"
        [searchable]="true"
        placeholder="No school selected"
      ></ng-select>
    </div>
    <div class="students-dropdown" *ngIf="studentsDropdown && initialStudent">
      <ng-select
        [items]="studentsDropdown"
        bindLabel="text"
        (change)="changeStudent($event)"
        [(ngModel)]="initialStudent"
        [clearable]="false"
        placeholder="No student selected"
      ></ng-select>
    </div>
  </div>
</div>
<messaging
  [errorMessage]="errorMessage"
  [successMessage]="successMessage"
></messaging>
